export const OWLS_LOCALIZED_AUTOCOMPLETE = 3320;
